// extracted by mini-css-extract-plugin
module.exports = {"container":"FilesUpload_container__2XTE1","property":"FilesUpload_property__3Tu36"};